class ProductAccordion extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'panel']
  }

  static get requiredExternalElements () {
    return ['parent']
  }

  static get styles () {
    return `
      :host {
        display: block;

        overflow: hidden;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.panelHeight = this.getPanelHeight()

    this.activate()
  }

  activate () {
    if (!this.isOpen) {
      this.els.panel.element.style.height = `0`
    }
  }

  deactivate () {
    this.els.panel.element.removeAttribute('style')
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
  }

  onTriggerClick () {
    if (!this.isOpen) {
      this.externalEls.parent.element.closeOtherAccordions(this)
    }
    this.isOpen = !this.isOpen
  }

  getPanelHeight () {
    const panel = this.els.panel.element
    panel.style.display = 'block'

    const height = panel.offsetHeight
    panel.removeAttribute('style')

    return height + this.additionalHeight
  }

  get isOpen () {
    return this.hasAttribute('open')
  }

  set isOpen (val) {
    if (val !== this.hasAttribute('open')) {
      val ? this.setAttribute('open', '') : this.removeAttribute('open')

      val
        ? window.BAO.Utils.slideDown(this.els.panel.element, this.panelHeight, {
          speed: 100,
        })
        : window.BAO.Utils.slideUp(this.els.panel.element, this.panelHeight, {
          speed: 100,
        })

      this.els.panel.element.setAttribute('aria-expanded', val.toString())
    }
  }

  get additionalHeight () {
    return Number(this.getAttribute('additional-height')) || 0
  }
}

class ProductAccordions extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['accordion']
  }

  closeOtherAccordions (openingAccordion) {
    this.els.accordion.elements.forEach(accordion => {
      if (openingAccordion !== accordion) {
        accordion.isOpen = false
      }
    })
  }
}

if (!customElements.get('product-accordion')) {
  customElements.define('product-accordion', ProductAccordion)
}

if (!customElements.get('product-accordions')) {
  customElements.define('product-accordions', ProductAccordions)
}
